import type { IconSvgObject } from './types';

const VideoReplayIcon: IconSvgObject = [
  ["path", { d: "M16.5 21.4997H4.5C3.39543 21.4997 2.5 20.6043 2.5 19.4997V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5H19.5C20.6046 2.5 21.5 3.39543 21.5 4.5V18.5L18.5 16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.5 14.1315V9.86852C9.5 9.06982 10.3901 8.59343 11.0547 9.03647L14.2519 11.1679C14.8457 11.5638 14.8457 12.4362 14.2519 12.8321L11.0547 14.9635C10.3901 15.4066 9.5 14.9302 9.5 14.1315Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default VideoReplayIcon;
